import { ChevronRightIcon } from '@heroicons/react/20/solid';
import { Link } from 'react-router-dom';
import { cloudEvalPath } from './cloudEvalRoutes';

export default function CloudEvalBreadcrumbs({ organization, client, evaluation, evaluationLabel }) {
  const items = [
    { label: 'Cloud Evals', to: cloudEvalPath() },
  ];

  if (organization) {
    items.push({
      label: organization.name || organization.id,
      to: cloudEvalPath({ organizationId: organization.id }),
    });
  }

  if (client) {
    items.push({
      label: client.Name || client.id,
      to: cloudEvalPath({ organizationId: organization.id, clientId: client.id }),
    });
  }

  if (evaluation) {
    items.push({
      label: evaluationLabel || evaluation.id,
      to: cloudEvalPath({
        organizationId: organization.id,
        clientId: client.id,
        evaluationId: evaluation.id,
      }),
    });
  }

  return (
    <nav aria-label="Breadcrumb" className="border-b border-gray-200 pb-4">
      <ol className="flex flex-wrap items-center gap-y-2 text-sm" role="list">
        {items.map((item, index) => {
          const current = index === items.length - 1;
          return (
            <li key={item.to} className="flex items-center">
              {index > 0 && (
                <ChevronRightIcon aria-hidden="true" className="mx-2 h-4 w-4 flex-shrink-0 text-gray-400" />
              )}
              {current ? (
                <span aria-current="page" className="font-medium text-gray-900">
                  {item.label}
                </span>
              ) : (
                <Link
                  className="font-medium text-gray-500 transition-colors hover:text-gray-900 focus:outline-none focus-visible:rounded-sm focus-visible:ring-2 focus-visible:ring-indigo-600 focus-visible:ring-offset-2"
                  to={item.to}
                >
                  {item.label}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
